import { CtaContentSection } from './contentTypes';
import { Cta, CtaProps } from './Cta';

interface CtaFromContentProps extends CtaContentSection {
  ctaProps?: CtaProps<string, string, number>;
  iconPosition?: 'start' | 'end';
}

export const CtaFromContent = ({ ctaProps, icon, iconPosition = 'start', label, to, variant }: CtaFromContentProps) => {
  return (
    <>
      {label && (
        <Cta
          action={to?.action}
          button={{
            ...ctaProps?.button,
            iconAriaHidden: true,
            iconEnd: icon && iconPosition === 'end' ? { ...ctaProps?.button?.iconEnd, name: icon } : undefined,
            iconStart: icon && iconPosition === 'start' ? { ...ctaProps?.button?.iconStart, name: icon } : undefined,
            label: label,
            variant: variant,
          }}
          code={to?.code}
          href={to?.href}
          link={{ ...ctaProps?.link }}
        />
      )}
    </>
  );
};
